import * as React from 'react'
import { Icons, IconNames } from './CustomVectors'

interface IconProperties {
    className?: string;
    title?: string;
    style?: any;
    role?: string;
    size?: string;
    fill?: string;
    name: IconNames;
}

export const CustomIcon: React.FC<IconProperties> = ({ title, size, name, fill, ...props }) => (
	<svg width={size} height={size} viewBox={Icons[name].viewBox} fill={fill} {...props}>
		{title &&
        <title>{title}</title>
		}
		{Icons[name].path}
	</svg>
)

CustomIcon.defaultProps = {
	size: '14px',
	role: 'img',
	fill: 'white',
}
